import React from 'react'


const ItemCard = ({ location, isLocationSelected, setCurrentLocation, onClick, uid,setSelectedLat,setSelectedLng}) => {
  return (
    <div>
        <>
        <div
        onClick={onClick}
        className={isLocationSelected === uid ? "card-item card-item-active" : "card-item"}
        >
                 <div className="card-item-titles">
                   <h3>{location.name}
                   </h3>
                   <div></div>
                   <h3 className='card-item-miles'></h3>
                 </div>
                 <p className="card-item-address">{location.streetaddress}</p>
                 {/* <p className="card-item-address">{location.city}</p> */}
               </div>
        </>
    </div>
  )
}

export default ItemCard